(function () {
  /* Session-only: the gate must reappear every time someone enters the site
     fresh (new tab / new browser session), not just once every 30 days —
     sessionStorage is cleared when the tab/browser closes, unlike
     localStorage or a long-lived cookie. */
  var STORAGE_KEY = 'bp_age_verified';

  function setVerified() {
    try {
      sessionStorage.setItem(STORAGE_KEY, '1');
    } catch (e) {}
  }

  document.addEventListener('DOMContentLoaded', function () {
    var gate = document.getElementById('age-gate');
    if (!gate) return;

    var isPending = document.documentElement.classList.contains('bp-age-pending');
    if (!isPending) return;

    var askPanel = gate.querySelector('[data-age-gate-ask]');
    var deniedPanel = gate.querySelector('[data-age-gate-denied]');
    var confirmButton = gate.querySelector('[data-age-gate-confirm]');
    var denyButton = gate.querySelector('[data-age-gate-deny]');

    requestAnimationFrame(function () {
      gate.classList.add('is-open');
    });

    confirmButton.addEventListener('click', function () {
      setVerified();
      gate.classList.remove('is-open');
      gate.classList.add('is-leaving');

      window.setTimeout(function () {
        gate.style.display = 'none';
        document.documentElement.classList.remove('bp-age-pending');
        document.documentElement.classList.add('bp-age-verified');
      }, 400);
    });

    denyButton.addEventListener('click', function () {
      askPanel.hidden = true;
      deniedPanel.hidden = false;
      window.setTimeout(function () {
        window.location.href = 'https://www.google.com';
      }, 2200);
    });
  });
})();
